import React from 'react'

export default function HomeBigimage() {
  return (
    <>
    <div className="home-bigimage">
        <div className="container">
            <div className="row justify-content-center">  

                <div className="col-lg-11">
                    <div className="bigimage-box">
                        <img src="/image/bigimage-1.webp" loading="lazy" className="img-responsive" alt="home"/>
                        <img src="/image/bigimage-2.webp" loading="lazy" className="wow animate__animated animate__fadeInRight" data-wow-duration="1.1s" data-wow-delay="0.2s" alt="home"/>
                    </div>
                </div>

            </div>
        </div>
    </div> 
    </>
  )
}
